export default __webpack_public_path__ + "static/Speed-380c66374f966230f03d2a0a04f5f9df.gif";